// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__1rkLn","sendOtp":"AuthorizeToLogin_sendOtp__1LO8J"};